import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
//import { AngularFireAuth} from "@angular/fire/compat/auth"
//import { FirebaseAuth } from "@angular/fire/compat";
//import { AngularFirestore, AngularFirestoreDocument } from "@angular/fire/compat/firestore";
import {BehaviorSubject, Observable, of} from 'rxjs';
import { switchMap } from 'rxjs/operators';

export interface User {
  uid: string;
  email: string;
}

@Injectable({
  providedIn: 'root'
})

export class LoginService {
    private http = inject(HttpClient);

    user$: Observable<User>;

  public loginAction(userData: User) {

  }



  private updateUserData(user) {
    // const userRef: AngularFirestoreDocument<User> = this.afs.doc(`users/${user.uid}`);
    //
    // const data = {
    //   uid: user.uid,
    //   email: user.email,
    //   displayName: user.displayName
    // };
    //
    // return userRef.set(data, {merge: true});
  }

  // async googleSignin() {
  //   const provider = new auth.GoogleAuthProvider();
  //   const credential = await this.afAuth.auth.signInWithPopup(provider);
  //   return this.updateUserData(credential.user);
  // }
  //
  // async googleSignOut() {
  //   await this.afAuth.auth.signOut();
  // }
  //
  // private login(userInfo: User) {
  //   this.http.post(environment + '/login', userInfo);
  // }
}
